import axios from 'axios';
import router from '../../router'
import {
    Notification,
    MessageBox,
    Loading
} from 'element-ui'
import qs from 'qs' // 直接post请求后台取不到参数,()
import CryptoJS from 'crypto-js/crypto-js'
import {compressAccurately} from 'image-conversion'


export function export2Excel(data){
    let loadingInstance = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });
    axios({
        method: data.method,
        url: `${data.url}`,
        //headers:{'Content-Type': 'application/json'},
        data: data.params,
        responseType: 'blob'//blob
    }).then((res) => {
        if( res.data.type == 'application/json'){
            if(res.headers['bizerror']){
                Notification.error({
                    title: '错误',
                    message: decodeURI(res.headers['bizerror']),
                    duration: 2000
                })
            } else {
                Notification.error({
                    title: '错误',
                    message: '下载失败'
                })
            }
            loadingInstance.close();
        } else {
            loadingInstance.close();
            const link = document.createElement('a')
            let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            if(res.headers['content-disposition'] != undefined){
                link.download = decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1])+'.xlsx'; //下载后文件名
            } else {
                link.download = data.fileName+'.xlsx'; //下载的文件名
            }
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }).catch(error => {
        Notification.error({
            title: '错误',
            message: '网络连接错误'
        })
    })
}
// const reader = new FileReader()
            // reader.onload = function () {
            //     const { msg } = JSON.parse(reader.res)
            //     alert(msg)
            // }
            // reader.readAsText(res)
// 默认的 KEY 与 iv 如果没有给

// 默认的 KEY 与 iv 如果没有给
let KEY = '';
console.log(process.env);
console.log(process.env.VUE_APP_CURRENTMODE);
if (process.env.NODE_ENV == 'development') {
  KEY = CryptoJS.enc.Utf8.parse("dddd11113d6ac01ad9dc6a123456test"); //""中与后台一样  密码
} else {
  // 测试环境 / 演示环境 / 生成环境
  KEY = CryptoJS.enc.Utf8.parse(process.env.VUE_APP_CRYPTOJS); //""中与后台一样  密码
}
const IV = CryptoJS.enc.Utf8.parse('');//""中与后台一样

/**
 * AES加密 ：字符串 key iv  返回base64
 */
export function encrypt(word, keyStr, ivStr) {
    let key = KEY
    let iv = IV

    if (keyStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr);
        iv = CryptoJS.enc.Utf8.parse(ivStr);
    }

    let srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    // console.log("-=-=-=-", encrypted.ciphertext)
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}

/**
 * AES 解密 ：字符串 key iv  返回base64
 *
 */
export function decrypt(word, keyStr, ivStr) {
    let key = KEY
    let iv = IV

    if (keyStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr);
        iv = CryptoJS.enc.Utf8.parse(ivStr);
    }

    let base64 = CryptoJS.enc.Base64.parse(word);
    let src = CryptoJS.enc.Base64.stringify(base64);

    var decrypt = CryptoJS.AES.decrypt(src, key, {
        iv: iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });

    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
}

async function getTargetFileSize(file, config = { maxWidth: 1400, maxHeight: 1400 }) {
  return new Promise(resolve => {
    const { maxWidth, maxHeight } = config;
    const reader = new FileReader();

    // 读取图片为 DataURL
    reader.readAsDataURL(file);
    reader.onload = () => {
    const img = new Image();
    img.src = reader.result;

    // 图片加载完成后，计算目标尺寸
    img.onload = () => {
      let targetWidth = img.width;
      let targetHeight = img.height;
      const originWidth = img.width;
      const originHeight = img.height;

      // 尺寸超限，等比例缩放
      if (originWidth > maxWidth || originHeight > maxHeight) {
        if (originWidth / originHeight > maxWidth / maxHeight) {
        // 按宽度限定
        targetWidth = maxWidth;
        targetHeight = Math.round(maxWidth * (originHeight / originWidth));
        } else {
          // 按高度限定
          targetHeight = maxHeight;
          targetWidth = Math.round(maxHeight * (originWidth / originHeight));
        }
      }

      resolve({ targetWidth, targetHeight });
      };
    };
  });
}

export async function compressImage(file, config = { accuracy: 0.9, size: 300 }) {
  // 打印压缩前大小（调试用）
  console.log("压缩前的大小", file.size / 1024);

  // 计算压缩后目标宽高（避免尺寸超限）
  const { targetWidth, targetHeight } = await getTargetFileSize(file);
  config.width = targetWidth;
  config.height = targetHeight;

  // 执行压缩，生成 Blob
  const resAvatarBlob = await compressAccurately(file, config);
  // Blob 转 File 对象（保留原文件名和类型）
  const resAvatarFile = new window.File(
      [resAvatarBlob],
      file.name,
      { type: file.type }
  );

  // 打印压缩后大小（调试用）
  console.log("压缩后的大小", resAvatarFile.size / 1024);
  return resAvatarFile; // 返回压缩后的 File 对象（Promise 包裹）
}

